import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type TeamFunctionName = keyof typeof teamFunctionEnum
export const teamFunctionEnum = {
  BUYER: { label: "Acheteur(se)", order: 0 },
  ACCOUNTANT: { label: "Comptable", order: 1 },
  BEAUTICIAN: { label: "Esthéticien(ne)", order: 2 },
  STUDENT: { label: "Étudiant(e)", order: 3 },
  ASSISTANT_PHARMACIST: { label: "Pharmacien(ne) adjoint(e)", order: 4 },
  PHARMACY_TECHNICIAN: { label: "Préparateur(trice) en pharmacie", order: 5 },
  STOCK_CLERK: { label: "Rayonniste", order: 6 },
  OTHER: { label: "Autre", order: 7 },
} as const satisfies ReferentialEnum<{ order: number }>
export const teamFunctionReferential = referentialEnumToReferentialCodeList(
  teamFunctionEnum,
).sort((a, b) => a.order - b.order)
